<template>
  <div class="addCostOriginValue">
    <div class="add-content-container">
      <div class="add-titieMain">
        <div class="add-title-container">资产原值单</div>
        <div class="add-content">
          <div class="operation-btn">
            <el-button size="small" class="del" @click="onDelete" :disabled="enableTable||!edit">删除</el-button>
            <el-button size="small" class="add" @click="onAdd" :disabled="enableTable||!edit">增加</el-button>
            <el-button size="small" class="alter" @click="onAlter" :disabled="enableTable||!edit">修改</el-button>
            <el-button size="small" class="save" @click="onSave" :disabled="!enableTable||!edit">保存</el-button>
            <el-button size="small" class="cancel" @click="onRollBack" :disabled="!enableTable||!edit">撤销</el-button>
            <el-button size="small" class="close" @click="$router.replace('/buyingAndSelling/fishSales')">关闭</el-button>
          </div>
          <div class="custom-search-container" >
            <div class="custom-search-box">
              <div class="custom-search-box-warpper">
                <span>日期</span>
                <el-date-picker size="small"  v-model="order.dataDate" type="date" placeholder="请选择日期" value-format="yyyy-MM-dd" :picker-options="pickerTimeOptions">
                </el-date-picker>
              </div>
              <div class="custom-search-box-warpper">
                <span>登记人</span>
                <el-select v-model="order.provider" filterable placeholder="请选择" size="small" @change="providerChange" >
                  <el-option v-for="(item, index) in providerList" :key="index" :label="item.value" :value="item.key">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="table-container">
        <table-ex :showIndex='true' :enable="enableTable&&edit">
          <thead-ex>
            <th-ex>基地</th-ex>
            <th-ex>类型</th-ex>
            <th-ex>资产名称</th-ex>
            <th-ex>资产原值</th-ex>
            <th-ex>残值率</th-ex>
            <th-ex>残值</th-ex>
            <th-ex>开始使用日期</th-ex>
            <th-ex>结束使用日期</th-ex>
            <th-ex>总折旧月数</th-ex>
            <th-ex>开始计提日期</th-ex>
            <th-ex>期初已折旧月数</th-ex>
            <th-ex>累计折旧(元)</th-ex>
          </thead-ex>
          <tbody-ex>
            <tr-ex v-for="(item,index) in order.details" :key="index" @selected="selectedRow=item">
              <td-ex v-model="item.baseId" :list="baseList" display="value" take="key" type='cmb' @selected="baseChange(item)"></td-ex>
              <td-ex v-model="item.typeId" :list="typeList" display="value" take="key" type='cmb' @selected="typeChange(item)"></td-ex>
              <td-ex v-model="item.assetName" type='input'></td-ex>
              <td-ex v-model="item.assetvalue" type='input'></td-ex>
              <td-ex v-model="item.rate" type='input'></td-ex>
              <td-ex v-model="item.value" type='input'>
              </td-ex>
              <td-ex v-model="item.startUse" type='cmb' :list="baseList" display="name" take="id" ></td-ex>
              <td-ex v-model="item.endUse" type='cmb' :list="baseList" display="name" take="id" ></td-ex>
              <td-ex v-model="item.allMonth" type='input'></td-ex>
              <td-ex v-model="item.startJi" type='cmb' :list="baseList" display="name" take="id" ></td-ex>
              <td-ex v-model="item.haveMonth" type='input'></td-ex>
              <td-ex v-model="item.money" type='input'></td-ex>
            </tr-ex>
          </tbody-ex>
          <tfoot-ex v-model="order.remark" :small-change-amount.sync="order.smallChangeAmount" @addRow="addRow" @delRow="delRow">
            <td>合计</td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
          </tfoot-ex>
        </table-ex> 
      </div>
    </div>
  </div>
</template>



<script>
import mixins from "@/common/MixIn.js";
export default {
  mixins: [mixins],
  name: "addCostOriginValue",
  data() {
    return {
      providerList: [],
      baseList: [],
      typeList: [],
      order: {
        provider: "",
        date: new Date(),
        remark: "",
        smallChangeAmount: 0,
        details: []
      },
      emptyRow: {
        baseId: null,
        typeId: null,
        assetName: "",
        assetvalue: "",
        rate: "",
        value: "",
        startUse: "",
        endUse: "",
        allMonth: "",
        startJi: "",
        haveMonth: ""
      },
      enableTable: false,
      // 限制日期
      pickerTimeOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      }
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    //初始化数据
    async initData() {
      if (!this.orderId) {
        this.initTable();
      } else {
        console.log("have orderId");
      }
      this.enableTable = true;
    },
    //初始化表格
    initTable() {
      this.order.details = [];
      this.$nextTick(() => this.addRow());
    },
    baseChange() {},
    typeChange() {},
    providerChange() {},
    onSave() {},
    onDelete() {},
    onAlter() {},
    onAdd() {},
    onRollBack() {},
    addRow() {
      let list = [];
      for (let i = 0; i < 5; i++) {
        list.push(JSON.parse(JSON.stringify(this.emptyRow)));
      }
      this.order.details = this.order.details.concat(list);
    },
    delRow() {
      this.order.details = this.order.details.filter(
        f => f != this.selectedRow
      );
    }
  }
};
</script>
<style lang="stylus" scoped>
.addCostOriginValue{
  .add-content-container{
    .add-titieMain{
      height: 190px;
      .add-content {
        height: 150px;
        .custom-search-container {
          margin-top: 25px;
        }
      }
    }
  }
}
</style>
